import { useState, useEffect, useRef } from "react";
import {
  Nav,
  Spinner,
  Callouts,
  Emulator,
  VideoOverlay,
  SimulatorInfo,
  Disclaimer,
} from "/application/webos/webos_tv_emulator/components";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import lgPageJSON from "/application/webos/webos_tv_emulator/json/lg-channels.json";
import whyWebOS from "/application/webos/webos_tv_emulator/json/web-os-advantages.json";
import webOStvHome from "/application/webos/webos_tv_emulator/json/web-os-tv-home.json";
import RCP from "/application/webos/webos_tv_emulator/json/rcp.json";
import EPG from "/application/webos/webos_tv_emulator/json/epg.json";
import magicOverview from "/application/webos/webos_tv_emulator/json/magic-remote-overview.json";
import directAccess from "/application/webos/webos_tv_emulator/json/direct-access.json";
import quickAccess from "/application/webos/webos_tv_emulator/json/quick-access.json";
import magicAI from "/application/webos/webos_tv_emulator/json/ai-voice.json";
import netflixVUI from "/application/webos/webos_tv_emulator/json/netflix-vui.json";
import iot from "/application/webos/webos_tv_emulator/json/iot.json";
import uei from "/application/webos/webos_tv_emulator/json/uei.json";
import realtek from "/application/webos/webos_tv_emulator/json/realtek.json";
import gaming from "/application/webos/webos_tv_emulator/json/gaming.json";
import sound from "/application/webos/webos_tv_emulator/json/sound.json";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import OpenWithIcon from "@material-ui/icons/OpenWith";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import SettingsOverscanIcon from "@material-ui/icons/SettingsOverscan";

import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";

import RotateRightIcon from "@material-ui/icons/RotateRight";

function App() {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState("home");
  const [videoOver, setVideoOver] = useState(false);
  const videoRef = useRef();
  const [introFinished, setIntroFinished] = useState(false);
  const [currentScreen, setCurrentScreen] = useState("/screens/0020");
  const [stepNumber, setStepNumber] = useState(1);
  const [emulatorStep, setEmulatorStep] = useState(0);
  const [hideEOv, setHideEOv] = useState(false);
  const [overlayOff, setOverlayOff] = useState(false);
  const [homeOverlay, setHomeOverlay] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      setIsAndroid(true);
    }
  }, []);

  const startVideo = () => {
    setLoading(false);
    setTimeout(() => {
      setVideoOver(true);
      setTimeout(() => {
        setHomeOverlay(true);
      }, 1000);
    }, 11000);
    // });
  };

  const { trackPageView } = useMatomo();
  useEffect(() => {
    trackPageView({ documentTitle: page, href: page });
  }, [page]);

  useEffect(() => {
    if (
      !loading &&
      document.getElementById("remote-overview") &&
      document.getElementById("remote-overview").classList
    ) {
      document
        .getElementById("remote-overview")
        .classList.add("remote-initial");
      document.getElementById("emulator").classList.add("remote-initial");
      if (document.getElementById("simulator")) {
        document.getElementById("simulator").classList.add("remote-initial");
      }
      setTimeout(() => {
        document
          .getElementById("remote-overview")
          .classList.remove("remote-initial");
        document.getElementById("emulator").classList.remove("remote-initial");
        if (document.getElementById("simulator")) {
          document
            .getElementById("simulator")
            .classList.remove("remote-initial");
        }
      }, 600);
    }
  }, [loading]);

  useEffect(() => {
    if (!introFinished && videoOver) {
      // setVideoOver(true);
      setIntroFinished(true);
      if (homeOverlay) {
        setHomeOverlay(false);
      }
    }
  }, [page]);

  const [resized, setResized] = useState(false);
  const handleWindowResize = () => {
    setResized(true);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  useEffect(() => {
    if (resized && !introFinished && !videoOver) {
      setHomeOverlay(true);
    }
  }, [resized]);

  useEffect(() => {
    console.log(`
██    ██ ██  ██████  █████  ██████  ██  ██████  ██    ██ ███████ 
██    ██ ██ ██      ██   ██ ██   ██ ██ ██    ██ ██    ██ ██      
██    ██ ██ ██      ███████ ██████  ██ ██    ██ ██    ██ ███████ 
 ██  ██  ██ ██      ██   ██ ██   ██ ██ ██    ██ ██    ██      ██ 
  ████   ██  ██████ ██   ██ ██   ██ ██  ██████   ██████  ███████ 
                                                                 
                                                                 
 ██████  ██████  ███    ██ ████████ ███████ ███    ██ ████████   
██      ██    ██ ████   ██    ██    ██      ████   ██    ██      
██      ██    ██ ██ ██  ██    ██    █████   ██ ██  ██    ██      
██      ██    ██ ██  ██ ██    ██    ██      ██  ██ ██    ██      
 ██████  ██████  ██   ████    ██    ███████ ██   ████    ██      
`);
    console.log("See more at https://www.vicariouscontent.com/");
  }, []);

  return (
    <>
      {loading && (
        <div
          className="fullscreen"
          style={{
            backgroundColor: "#333",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <img
            src="/application/webos/webos_tv_emulator/images/logo-webos.svg"
            className="logo"
            alt="webOS logo"
            style={{ marginBottom: "1rem" }}
          />{" "}
          TV
          <Spinner />
        </div>
      )}
      <div
        className="fullscreen"
        // style={{ cursor: 'url("/application/webos/webos_tv_emulator/images/webos-cursor.png"), auto' }}
      >
        <div className="overlay">
          <div className="iconContainer">
            <div className="phone">
              <RotateRightIcon />
            </div>
            <p style={{ fontSize: "1.5rem" }}>Rotate your device</p>
          </div>
        </div>
        {page === "home" && !videoOver && !resized && (
          <VideoOverlay
            loading={loading}
            videoRef={videoRef}
            startVideo={startVideo}
          />
        )}
        {!loading && (
          <>
            <div
              className="stickyheader"
              style={{
                backgroundColor: page === "magic_remote" ? "#121212" : "#000",
                animationDelay: resized ? "0s" : "7s",
              }}
            >
              <img
                src="/application/webos/webos_tv_emulator/images/logo-webos.svg"
                className="logo"
                alt="webOS logo"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setPage("home");
                }}
              />
            </div>
            <Nav
              setPage={setPage}
              page={page}
              emulatorStep={emulatorStep}
              setEmulatorStep={setEmulatorStep}
              setCurrentScreen={setCurrentScreen}
              resized={resized}
            />

            <div
              className="background-container"
              style={{
                pointerEvents: videoOver || resized ? "all" : "none",
                animation:
                  page === "home"
                    ? "1s bg-color-tobrown forwards"
                    : "0.5s bg-color-towhite forwards",
              }}
            >
              {page === "home" ? (
                <>
                  <div
                    className="topright-title"
                    onClick={() => {
                      setHomeOverlay(!homeOverlay);
                    }}
                  >
                    <p
                      className="special-right-title"
                      style={{
                        fontSize: "2.5rem",
                        fontFamily: "LG_Smart_Bold",
                        color: "#c20839",
                        lineHeight: window.navigator.platform.includes("Win")
                          ? "44px"
                          : "60px",
                        margin: window.navigator.platform.includes("Win")
                          ? "0"
                          : "-5px 0 0 0",
                        whiteSpace: "nowrap",
                        display: "inline",
                        opacity: "0",
                        animation: "0.3s linear forwards fadeIn",
                        animationDelay: videoOver || resized ? "0s" : "10s",
                      }}
                    >
                      webOS TV Home
                    </p>
                    <Tooltip title="Toggle Help" arrow placement="left">
                      <HelpOutlineIcon
                        className="toggleHelp"
                        style={{
                          height: "37px",
                          width: "37px",
                          opacity: 0,
                          animation: "0.3s linear forwards fadeIn",
                          animationDelay: videoOver || resized ? "0s" : "10s",
                        }}
                      />
                    </Tooltip>
                  </div>

                  <div
                    className={
                      page !== "home"
                        ? "hide webos-home callouts ov-scale"
                        : "webos-home callouts ov-scale"
                    }
                    style={{
                      pointerEvents: videoOver || resized ? "all" : "none",
                    }}
                  >
                    <img
                      className="bezel"
                      src="/application/webos/webos_tv_emulator/images/tv-bezel-transp.png"
                      alt="LG TV"
                      style={{
                        pointerEvents:
                          (videoOver && homeOverlay) || (resized && homeOverlay)
                            ? "all"
                            : "none",
                        animationDelay: videoOver || resized ? "0s" : "1s",
                      }}
                    />
                    <Callouts
                      resized={resized}
                      homeOverlay={homeOverlay}
                      videoOver={videoOver}
                      page="home"
                      introFinished={introFinished}
                    />

                    {homeOverlay ? (
                      <>
                        <div
                          className="screen"
                          style={{
                            zIndex: 19,
                            backgroundColor: "rgba(0,0,0,0.8)",
                            height: "540px",
                            width: "960px",
                            top: "calc(50% - 273px)",
                            left: "calc(50% - 478px)",
                            color: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            opacity: 0,
                            animation: "0.3s linear forwards fadeIn",
                          }}
                        >
                          <CloseIcon
                            style={{
                              color: "white",
                              fontSize: "1.8rem",
                              position: "absolute",
                              top: 20,
                              right: 20,
                              cursor: "pointer",
                              zIndex: 28,
                            }}
                            onClick={() => {
                              setHomeOverlay(false);
                            }}
                          />

                          <div
                            style={{
                              height: "calc(100% - 80px)",
                              width: "calc(100% - 40px)",
                              padding: "68px 20px 100px 20px",
                              position: "relative",
                              color: "white",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "2rem",
                                textAlign: "center",
                                marginBottom: "12px",
                              }}
                            >
                              How to use the webOS TV Overview?
                            </p>
                            <hr
                              style={{
                                height: "1px",
                                border: "none",
                                backgroundColor: "white",
                                width: "470px",
                              }}
                            />

                            <p
                              style={{
                                fontWeight: 400,
                                fontSize: "1.4rem",
                                textAlign: "center",
                                padding: "0 260px 80px 260px",
                              }}
                            >
                              Hover over the{" "}
                              <span
                                style={{ color: "#ff0099", fontWeight: 900 }}
                              >
                                highlighted
                              </span>{" "}
                              areas to see more information about different
                              <br /> features of webOS TV.
                              <br />
                              <hr
                                style={{
                                  marginTop: "25px",
                                  height: "1px",
                                  border: "none",
                                  backgroundColor: "white",
                                  width: "470px",
                                }}
                              />
                              <SettingsOverscanIcon
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  opacity: 0.6,
                                  marginBottom: "-9px",
                                  marginRight: "12px",
                                }}
                              />
                              <small>
                                We recommend viewing this site in full screen.{" "}
                                <br />
                                <p style={{ marginTop: "10px" }}>
                                  Optimized for devices with 10.5" screens or
                                  larger
                                </p>
                              </small>
                            </p>
                            <br />
                            <br />
                          </div>
                        </div>
                      </>
                    ) : null}
                    {!videoOver && !resized ? (
                      <img
                        className="screenfadeinout"
                        style={{
                          animationDelay: "6.2s",
                          zIndex: 11,
                        }}
                        src="/application/webos/webos_tv_emulator/images/emulator/webos-splash.png"
                        alt="webOS Homescreen"
                      />
                    ) : null}
                    <img
                      className="screen"
                      src="/application/webos/webos_tv_emulator/images/overview/home-1.jpg"
                      alt="webOS Homescreen"
                      style={{
                        animationDelay: videoOver || resized ? "0s" : "8s",
                        zIndex: 4,
                        height: "540px",
                        width: "960px",
                        top: "calc(50% - 273px)",
                        left: "calc(50% - 478px)",
                      }}
                    />
                    <img
                      className="screen"
                      style={{
                        zIndex: 6,
                        animationDelay: videoOver || resized ? "0.3s" : "9s",
                        height: "540px",
                        width: "960px",
                        top: "calc(50% - 273px)",
                        left: "calc(50% - 478px)",
                      }}
                      src="/application/webos/webos_tv_emulator/images/overview/home-2.jpg"
                      alt="webOS Homescreen"
                    />
                    <img
                      className="screen"
                      style={{
                        zIndex: 9,
                        opacity: 0,
                        animationDelay: videoOver || resized ? "0.6s" : "10s",
                        height: "540px",
                        width: "960px",
                        top: "calc(50% - 273px)",
                        left: "calc(50% - 478px)",
                        cursor: 'url("/application/webos/webos_tv_emulator/images/webos-cursor.png"), auto',
                      }}
                      src="/application/webos/webos_tv_emulator/images/overview/home-3.jpg"
                      alt="webOS Homescreen"
                    />

                    <img
                      className="bezel"
                      src="/application/webos/webos_tv_emulator/images/tv-bezel-transp.png"
                      alt="LG TV"
                      style={{
                        animationDelay: videoOver || resized ? "0s" : "3s",
                      }}
                    />
                  </div>
                  <Disclaimer overview={true} />
                </>
              ) : null}

              <div
                id="emulator"
                className={
                  page !== "Emulator" ? "hide webos-home" : "show webos-home"
                }
              >
                <Emulator
                  isAndroid={isAndroid}
                  page={page}
                  hideEOv={hideEOv}
                  setHideEOv={setHideEOv}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                />
              </div>

              {page === "magic_remote" ? (
                <div
                  id="remote-overview"
                  className={page !== "magic_remote" ? "hide" : "show "}
                  style={{ animation: "0s bg-color-tobrown forwards" }}
                >
                  <p
                    id="mre-title"
                    className="special-right-title"
                    style={{
                      fontSize: "2.5rem",
                      fontFamily: "LG_Smart_Bold",
                      color: "#c20839",
                      width: "100px",
                      position: "absolute",
                      lineHeight: window.navigator.platform.includes("Win")
                        ? "40px"
                        : null,
                      margin: window.navigator.platform.includes("Win")
                        ? "0"
                        : "-5px 0 0 0",
                      whiteSpace: "nowrap",
                      display: "inline",
                    }}
                  >
                    Magic Remote
                  </p>

                  <div className="remotebg-dark">
                    <Callouts
                      videoOver={videoOver}
                      resized={resized}
                      page="magic_remote"
                      introFinished={introFinished}
                    />
                    <img
                      className="remote-dark"
                      src="/application/webos/webos_tv_emulator/images/overview/magic-remote2.png"
                      alt="LG Magic Remote"
                    />
                  </div>
                  <Disclaimer overview={true} remote={true} noScreen={true} />
                </div>
              ) : null}

              {page === "web-os-advantages" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={whyWebOS}
                  setStepNumber={setStepNumber}
                  prevTopic={"sound"}
                  nextTopic={"web-os-tv-home"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "web-os-tv-home" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={webOStvHome}
                  setStepNumber={setStepNumber}
                  prevTopic={"web-os-advantages"}
                  nextTopic={"RCP"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "RCP" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={RCP}
                  setStepNumber={setStepNumber}
                  prevTopic={"web-os-tv-home"}
                  nextTopic={"lg-channels"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "lg-channels" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={lgPageJSON}
                  prevTopic={"RCP"}
                  nextTopic={"EPG"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "EPG" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={EPG}
                  setStepNumber={setStepNumber}
                  prevTopic={"lg-channels"}
                  nextTopic={"overview-magic-remote"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "overview-magic-remote" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={magicOverview}
                  setStepNumber={setStepNumber}
                  prevTopic={"EPG"}
                  nextTopic={"direct-access-magic-remote"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "direct-access-magic-remote" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={directAccess}
                  setStepNumber={setStepNumber}
                  prevTopic={"overview-magic-remote"}
                  nextTopic={"quick-access-magic-remote"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "quick-access-magic-remote" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={quickAccess}
                  setStepNumber={setStepNumber}
                  prevTopic={"direct-access-magic-remote"}
                  nextTopic={"ai-voice-magic-remote"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  setEmulatorStep={setEmulatorStep}
                  page={page}
                />
              ) : null}
              {page === "ai-voice-magic-remote" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={magicAI}
                  setStepNumber={setStepNumber}
                  prevTopic={"quick-access-magic-remote"}
                  nextTopic={"netflix-vui"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}

              {page === "netflix-vui" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={netflixVUI}
                  setStepNumber={setStepNumber}
                  prevTopic={"ai-voice-magic-remote"}
                  nextTopic={"uei"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}

              {page === "uei" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={uei}
                  setStepNumber={setStepNumber}
                  prevTopic={"netflix-vui"}
                  nextTopic={"iot"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}

              {page === "iot" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={iot}
                  setStepNumber={setStepNumber}
                  prevTopic={"uei"}
                  nextTopic={"realtek"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}

              {page === "realtek" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={realtek}
                  setStepNumber={setStepNumber}
                  prevTopic={"iot"}
                  nextTopic={"gaming"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "gaming" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={gaming}
                  setStepNumber={setStepNumber}
                  prevTopic={"realtek"}
                  nextTopic={"sound"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
              {page === "sound" ? (
                <SimulatorInfo
                  isAndroid={isAndroid}
                  pageJSON={sound}
                  setStepNumber={setStepNumber}
                  prevTopic={"gaming"}
                  nextTopic={"web-os-advantages"}
                  setPage={setPage}
                  emulatorStep={emulatorStep}
                  setEmulatorStep={setEmulatorStep}
                  currentScreen={currentScreen}
                  setCurrentScreen={setCurrentScreen}
                  page={page}
                />
              ) : null}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default App;
